import { z } from 'zod';
export const resourceTaggingServiceName = 'resource-tagging';
export const ResourceTaggingParameterSchema = z.enum(['RESOURCE_TAGGING_BASE_URL']);
export const ResourceTaggingParameterEnum = ResourceTaggingParameterSchema.enum;
